
import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../Constants';

const NewsLetter: React.FC = () => {

    const useIsMobile = (breakpoint = 768) => {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
          };
      
          window.addEventListener('resize', handleResize);
      
          // Limpia el evento cuando el componente se desmonta
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        }, [breakpoint]);
      
        return isMobile;
    };

    const isMobile = useIsMobile();

    const [formData, setFormData] = useState({
        nombres: '',
        telefono: '',
        email: '',
        dni: '',
        servicio: '',
        politicas: false,
        publicidad: false,
        compartir: false
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        if (type === 'checkbox') {
            const checked = (e.target as HTMLInputElement).checked;
            setFormData(prev => ({
                ...prev,
                [name]: checked
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubscribe = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
          const response = await fetch('/send-email.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          const result = await response.json();

          if (response.ok && result.success) {
            alert('Mensaje enviado exitosamente. Nos pondremos en contacto contigo pronto.');
            setFormData({
                nombres: '',
                telefono: '',
                email: '',
                dni: '',
                servicio: '',
                politicas: false,
                publicidad: false,
                compartir: false
            });
          } else {
            alert('Error al enviar el mensaje: ' + (result.message || 'Error desconocido'));
          }
        } catch (error) {
          console.error('Error al enviar el formulario:', error);
          alert('Error de conexión. Por favor, intenta nuevamente.');
        }
      };

  return (
    <>
        <section id="newsletter-section" style={{
            backgroundColor: '#023352',
            padding: '60px 0',
            color: 'white'
        }}>
            <div className="container">
                <div style={{
                    textAlign: 'center',
                    marginBottom: '40px'
                }}>
                    <h2 style={{
                        fontSize: '42px',
                        fontWeight: '700',
                        margin: '0',
                        fontFamily: 'Axiforma-Bold, sans-serif', 
                        fontStyle: 'italic',
                        color: 'white'
                    }}>
                         ¡Contáctanos!

                    </h2>
                </div>

                <div style={{
                    maxWidth: '900px',
                    margin: '0 auto',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '20px',
                    padding: '40px',
                    color: '#333'
                }}>
                    <form onSubmit={handleSubscribe}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                            gap: '20px',
                            marginBottom: '20px'
                        }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}>
                                    Nombres y apellidos
                                </label>
                                <input
                                    type="text"
                                    name="nombres"
                                    value={formData.nombres}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Axiforma-Regular, sans-serif'
                                    }}
                                    required
                                />
                            </div>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}>
                                    Teléfono
                                </label>
                                <input
                                    type="tel"
                                    name="telefono"
                                    value={formData.telefono}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Axiforma-Regular, sans-serif'
                                    }}
                                    required
                                />
                            </div>
                        </div>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                            gap: '20px',
                            marginBottom: '20px'
                        }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Axiforma-Regular, sans-serif'
                                    }}
                                    required
                                />
                            </div>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}>
                                    DNI
                                </label>
                                <input
                                    type="text"
                                    name="dni"
                                    value={formData.dni}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Axiforma-Regular, sans-serif'
                                    }}
                                    required
                                />
                            </div>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontWeight: '600',
                                fontSize: '14px'
                            }}>
                                Escriba el servicio de su interés
                            </label>
                             <input
                                    type="text"
                                    name="servicio"
                                    value={formData.servicio}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontFamily: 'Axiforma-Regular, sans-serif'
                                    }}
                                    required
                                />
                        </div>

                        <div style={{ marginBottom: '30px' }}>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}>
                                    <input
                                        type="checkbox"
                                        name="politicas"
                                        checked={formData.politicas}
                                        onChange={handleInputChange}
                                        style={{
                                            marginRight: '10px',
                                            transform: 'scale(1.2)'
                                        }}
                                        required
                                    />
                                    <span>
                                    <strong>He leído y acepto las Políticas de Privacidad</strong>
                                    </span>
                                </label>
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}>
                                    <input
                                        type="checkbox"
                                        name="publicidad"
                                        checked={formData.publicidad}
                                        onChange={handleInputChange}
                                        style={{
                                            marginRight: '10px',
                                            transform: 'scale(1.2)'
                                        }}
                                    />
                                   <strong>Autorizo a que me envíen publicidad y/o promociones</strong> 
                                </label>
                            </div>
                            <div>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}>
                                    <input
                                        type="checkbox"
                                        name="compartir"
                                        checked={formData.compartir}
                                        onChange={handleInputChange}
                                        style={{
                                            marginRight: '10px',
                                            transform: 'scale(1.2)'
                                        }}
                                    />
                                    <strong>Autorizo que mi información sea compartida con el resto de empresas del grupo</strong> 
                                </label>
                            </div>
                        </div>

                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '15px',
                                backgroundColor: '#023352',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                fontFamily: 'Axiforma-Regular, sans-serif',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#2a5a82';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#1e4a72';
                            }}
                        >
                            Enviar
                        </button>
                    </form>
                </div>
            </div>
        </section>
    </>
  );
};

export default NewsLetter;